import API from '../utils/api';
import { ENDPOINT_URL } from '../constants/defaultValues';

const getCoupon = async ({ couponNumber }) => {
    try {
        const res = await API.get(`${ENDPOINT_URL}/book-bet/${couponNumber}`);

        return res.data;
    } catch (error) {
        console.error(error);
        return { info: { success: false } };
    }
};

const depositVoucher = async ({ voucherCode, ...data }) => {
    return API.put(`${ENDPOINT_URL}/vouchers/deposit/${voucherCode}`, data);
};

const getMaxStake = async data => {
    const result = await API.post(`${ENDPOINT_URL}/tickets/max-stake`, data);

    return result.data;
};

const getTicketByRequestId = async ({ requestId }) => {
    const result = await API.get(`${ENDPOINT_URL}/tickets/verify/${requestId}`);

    return result.data;
};

const BookBetService = {
    getCoupon,
    depositVoucher,
    getMaxStake,
    getTicketByRequestId,
};

export default BookBetService;
